<template>
  <div class="home" :class="viewportHeight <= 900 ? 'section_hh' : ''">
    <div class="swipe-section">
      <div class="section_b1 panel">
        <div class="main_contain">
          <div class="wrap_title_boxs">
            <img
              v-motion-pop-visible
              class="banner_logo"
              src="@/assets/img/logo_white.png"
              alt=""
            />
            <div v-motion-pop-visible class="wrap_title">
              屈光眼科<br class="visible-xs-block" />综合服务平台
            </div>
            <div v-motion-pop-visible class="wrap_tip">
              Smarter Ophthalmic Informatics Platform
            </div>
          </div>
          <img class="wrap_eye" src="@/assets/img/icon_eye.png" alt="" />
          <div class="wrap_bottom_com">广州有济于世信息科技有限公司</div>
        </div>
      </div>

      <div class="section_b2 panel">
        <div class="section_b2_top section_ttbg"></div>
        <div class="section_b2_bottom">
          <div class="main_contain">
            <div class="b2_tboxs">
              <div class="ban_title_boxs">
                <div
                  class="active_block"
                  :style="{ '--offset-multiple': `${currentB3Index - 1}` }"
                ></div>
                <div
                  class="ban_title"
                  :class="currentB3Index === 1 ? 'ban_title_active' : ''"
                  @click="currentB3Index = 1"
                >
                  关于我们
                </div>
                <div
                  class="ban_title"
                  :class="currentB3Index === 2 ? 'ban_title_active' : ''"
                  @click="currentB3Index = 2"
                >
                  资质证书
                </div>
              </div>

              <div v-motion-pop-visible class="b2_content">
                <span>广州有济于世信息科技有限公司，</span
                >是一家专门从事眼科信息化解决方案的专业软件公司。公司致力于为眼科业务提供全流程信息化、数字化、智能化的解决方案。公司自主研发眼科信息化平台，采用人工智能，大数据分析等业内先进技术，支持定制化嵌入客户的终端系统，为智能化医疗赋能助力。
              </div>
            </div>
          </div>
        </div>
        <!-- 证书遮罩 -->
        <Transition name="certificate">
          <div
            v-show="currentB3Index === 2"
            @click.self="currentB3Index = 1"
            class="section_b2_certificate"
          >
            <div class="section_b2_cswiper">
              <swiper
                class="swiper_b2_section"
                :autoHeight="true"
                :modules="modules"
                :slides-per-view="1"
                :space-between="0"
                effect="fade"
                :navigation="{
                  nextEl: '.swiper_button_next',
                  prevEl: '.swiper_button_prev',
                }"
                :pagination="{ clickable: true }"
                @slideChange="onSlideB2Change"
              >
                <swiper-slide>
                  <div class="swiper_b2_item">
                    <img
                      class="swiper_box_img hidden-xs"
                      src="@/assets/img/certificate1.png"
                      alt=""
                    />
                    <img
                      class="swiper_box_img visible-xs-block"
                      src="@/assets/img/certificate1_m.png"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="swiper_b2_item">
                    <img
                      class="swiper_box_img hidden-xs"
                      src="@/assets/img/certificate2.png"
                      alt=""
                    />
                    <img
                      class="swiper_box_img visible-xs-block"
                      src="@/assets/img/certificate2_m.png"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="swiper_b2_item">
                    <img
                      class="swiper_box_img hidden-xs"
                      src="@/assets/img/certificate3.png"
                      alt=""
                    />
                    <img
                      class="swiper_box_img swiper_box_img2 visible-xs-block"
                      src="@/assets/img/certificate3_m.png"
                      alt=""
                    />
                  </div>
                </swiper-slide>
                <div
                  v-show="currentTbIndex != 3"
                  class="swiper_button_next"
                  style="right: 10%"
                ></div>
                <div
                  v-show="currentTbIndex != 1"
                  class="swiper_button_prev"
                  style="left: 10%"
                ></div>
              </swiper>
            </div>
          </div>
        </Transition>
      </div>

      <div class="section_b3 panel">
        <div class="main_contain">
          <div class="section_b3_boxs">
            <div class="ban_title_boxs">
              <div
                class="active_block"
                :style="{ '--offset-multiple': `${currentB2Index - 1}` }"
              ></div>
              <div
                class="ban_title"
                :class="currentB2Index === 1 ? 'ban_title_active' : ''"
                @click="goToSlide(0)"
              >
                平台介绍
              </div>
              <div
                class="ban_title"
                :class="currentB2Index === 2 ? 'ban_title_active' : ''"
                @click="goToSlide(1)"
              >
                产品全景图
              </div>
            </div>
            <swiper
              class="swipe_b3_section"
              :slides-per-view="1"
              :space-between="0"
              effect="fade"
              @swiper="onSwiper"
              @slideChange="onSlideChange"
            >
              <swiper-slide>
                <div class="b3_main_act">
                  <div v-motion-pop-visible class="b3_main_tt">
                    <div class="b3_t_b1">以科技 + 服务引领屈光未来</div>
                    <div class="b3_t_b2">与行业合作伙伴共建行业新生态</div>
                  </div>

                  <div v-motion-pop-visible class="b3_main_tip">
                    <span>济济</span>
                    是一个屈光眼科综合服务平台。我们用创新的产品和服务，将医疗机构、药械供应商、屈光不正人士以及相关服务提供商连接到一起，和行业同仁一起，打造更好的屈光生态，提升行业效率，改善屈光人群的生活质量。
                  </div>

                  <div v-motion-pop-visible class="b3_main_btns">
                    <div class="b3_main_btn">医疗机构</div>
                    <div class="b3_main_btn">药械供应商</div>
                    <div class="b3_main_btn">屈光不正人士</div>
                    <div class="b3_main_btn">服务提供商</div>
                    <div class="b3_main_btn">其他商户</div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <img
                  class="banner_product hidden-xs"
                  src="@/assets/img/banner_product_all.png"
                  alt=""
                />
                <img
                  @click="openItemGallery(banner_product_all_m)"
                  class="banner_product visible-xs-block"
                  :src="banner_product_all_m"
                  alt=""
                />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>

      <div class="section_b4 panel">
        <div class="main_contain">
          <div class="section_b4_boxs">
            <div class="ban_title_boxs">
              <div
                class="active_block"
                :style="{ '--offset-multiple': `${currentB8Index - 1}` }"
              ></div>
              <div
                class="ban_title"
                :class="currentB8Index === 1 ? 'ban_title_active' : ''"
                @click="goToSlideB8(0)"
              >
                医疗机构解决方案
              </div>
              <div
                class="ban_title"
                :class="currentB8Index === 2 ? 'ban_title_active' : ''"
                @click="goToSlideB8(1)"
              >
                用户解决方案
              </div>
              <div
                class="ban_title"
                :class="currentB8Index === 3 ? 'ban_title_active' : ''"
                @click="goToSlideB8(2)"
              >
                药械供应商解决方案
              </div>
              <div
                class="ban_title"
                :class="currentB8Index === 4 ? 'ban_title_active' : ''"
                @click="goToSlideB8(3)"
              >
                服务提供商解决方案
              </div>
            </div>
            <swiper
              class="swipe_b4_section"
              :slides-per-view="1"
              :space-between="0"
              effect="fade"
              @swiper="onSwiperB8"
              @slideChange="onSlideChangeB8"
            >
              <swiper-slide>
                <img
                  class="banner_product hidden-xs"
                  src="@/assets/img/banner_product_b8c1.png"
                  alt=""
                />
                <img
                  class="banner_product visible-xs-block"
                  @click="openGallery(banner_product_b8c1_m)"
                  :src="banner_product_b8c1_m"
                  alt=""
                />
              </swiper-slide>
              <swiper-slide>
                <img
                  class="banner_product hidden-xs"
                  src="@/assets/img/banner_product_b8c2.png"
                  alt=""
                />
                <img
                  class="banner_product visible-xs-block"
                  @click="openGallery(banner_product_b8c2_m)"
                  :src="banner_product_b8c2_m"
                  alt=""
                />
              </swiper-slide>
              <swiper-slide>
                <img
                  class="banner_product hidden-xs"
                  src="@/assets/img/banner_product_b8c3.png"
                  alt=""
                />
                <img
                  class="banner_product visible-xs-block"
                  @click="openGallery(banner_product_b8c3_m)"
                  :src="banner_product_b8c3_m"
                  alt=""
                />
              </swiper-slide>
              <swiper-slide>
                <img
                  class="banner_product hidden-xs"
                  src="@/assets/img/banner_product_b8c4.png"
                  alt=""
                />
                <img
                  class="banner_product visible-xs-block"
                  @click="openGallery(banner_product_b8c4_m)"
                  :src="banner_product_b8c4_m"
                  alt=""
                />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>

      <div class="section_b5 panel">
        <div class="section_b5_top section_ttbg"></div>
        <div class="section_b5_bottom">
          <div class="main_contain">
            <div class="b5_tboxs">
              <div v-motion-pop-visible class="b5_title">信息安全</div>

              <div v-if="!isMoblie" class="b5_main_boxs">
                <div class="b5_main_item">
                  <div class="b5_main_item_t">数据私隐保护</div>
                  <div class="b5_main_item_content">
                    严格遵守相关法律法规，采取安全的数据存储和传输技术，确保用户个人信息和医疗数据的隐私和安全。通过加密技术、访问权限控制等手段来防止未经授权的访问或泄露。
                  </div>
                </div>

                <div class="b5_main_item">
                  <div class="b5_main_item_t">防止欺诈和滥用</div>
                  <div class="b5_main_item_content">
                    平台设有风险监测和反欺诈机制，通过数据分析和算法监控异常活动和可疑行为，以及对用户提交信息的验证和核实，从而防止欺诈和滥用情况的发生。
                  </div>
                </div>

                <div class="b5_main_item">
                  <div class="b5_main_item_t">安全认证和合规</div>
                  <div class="b5_main_item_content">
                    平台与专业的安全机构合作，进行安全审计和认证，确保产品符合行业标准和最佳实践。同时，积极响应并遵循相关的法规和合规要求，例如个人信息保护法、医疗健康数据管理规定等并取得安全等级保护三级认证。
                  </div>
                </div>
              </div>

              <div v-else class="b5_main_boxs b5_main_boxs_m">
                <swiper
                  class="swipe_b4_section"
                  :modules="modules"
                  :slides-per-view="1"
                  :space-between="0"
                  effect="fade"
                  :navigation="{
                    nextEl: '.swiper_button_next_m',
                    prevEl: '.swiper_button_prev_m',
                  }"
                  @slideChange="onSlideB5Change"
                >
                  <swiper-slide>
                    <div class="b5_main_item b5_main_item_m">
                      <div class="b5_main_item_t">数据私隐保护</div>
                      <div class="b5_main_item_content">
                        严格遵守相关法律法规，采取安全的数据存储和传输技术，确保用户个人信息和医疗数据的隐私和安全。通过加密技术、访问权限控制等手段来防止未经授权的访问或泄露。
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div class="b5_main_item b5_main_item_m">
                      <div class="b5_main_item_t">防止欺诈和滥用</div>
                      <div class="b5_main_item_content">
                        平台设有风险监测和反欺诈机制，通过数据分析和算法监控异常活动和可疑行为，以及对用户提交信息的验证和核实，从而防止欺诈和滥用情况的发生。
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div class="b5_main_item b5_main_item_m">
                      <div class="b5_main_item_t">安全认证和合规</div>
                      <div class="b5_main_item_content">
                        平台与专业的安全机构合作，进行安全审计和认证，确保产品符合行业标准和最佳实践。同时，积极响应并遵循相关的法规和合规要求，例如个人信息保护法、医疗健康数据管理规定等并取得安全等级保护三级认证。
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
                <div class="swiper_button_next_m">
                  <img
                    class="banner_arrow_left"
                    src="@/assets/img/icon_arrow.png"
                    alt=""
                  />
                </div>
                <div class="swiper_button_prev_m">
                  <img
                    class="banner_arrow"
                    src="@/assets/img/icon_arrow.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section_b6 panel">
        <div class="section_b6_top section_ttbg"></div>
        <div class="section_b6_bottom">
          <div class="b6_boxs">
            <div v-if="!isMoblie" class="b6_boxs_left">
              <!-- <div id="allmap"></div> -->
              <img class="baiduMap" src="@/assets/img/baiduMap.png" alt="" />
            </div>

            <div class="b6_boxs_right">
              <div v-motion-pop-visible class="b6_r_title">联系方式</div>
              <div class="b6_r_wboxs">
                <div class="b6_r_wrap"><span>联系电话：</span>13759982847</div>
                <div class="b6_r_wrap"><span>邮箱：</span>info@gigitech.cn</div>
                <div class="b6_r_wrap">
                  <span>地址：</span>广州市珠江新城兴民路222号天盈广场西塔1905室
                </div>
              </div>

              <div class="b6_rt_boxs">
                <div class="b6_rt_boxs_l">
                  <div v-motion-pop-visible class="b6_r_title b6_r_title_liu">
                    留言
                  </div>
                  <div class="b6_rt_tip">
                    填写你的大概信息，我们会及时安排业务专员和您联系!
                  </div>
                </div>
                <div @click="takeItShow" class="b6_r_title b6_rt_btn">
                  按此留信息
                </div>
              </div>

              <div class="b6_rtt_wboxs">
                <div class="b6_rtt_wrap">
                  <div class="b6_r_wrap_item">
                    <span>您的称呼:</span>
                    <input
                      v-model="infoFrom.name"
                      class="b6_r_wrap_input"
                      type="text"
                    />
                  </div>
                  <div class="b6_r_wrap_item" style="padding-left: 40px">
                    <span>您的邮箱:</span>
                    <input
                      v-model="infoFrom.email"
                      class="b6_r_wrap_input"
                      type="text"
                    />
                  </div>
                </div>
                <div class="b6_rtt_wrap">
                  <div class="b6_r_wrap_item">
                    <span>您的电话:</span>
                    <input
                      v-model="infoFrom.phone"
                      class="b6_r_wrap_input"
                      type="text"
                    />
                  </div>
                  <div class="b6_r_wrap_item" style="padding-left: 40px">
                    <span>所在公司:</span>
                    <input
                      v-model="infoFrom.company"
                      class="b6_r_wrap_input"
                      type="text"
                    />
                  </div>
                </div>
              </div>

              <div
                class="b6_r_title b6_rt_btn_m visible-xs-block"
                @click="takeItShow"
              >
                按此留信息
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isMoblie" class="b6_boxs_map">
        <!-- <div id="allmap"></div> -->
        <img class="baiduMap" src="@/assets/img/baiduMap.png" alt="" />
      </div>

      <div class="section_b7 panel">
        <div class="main_contain">
          <div class="b7_boxs">
            <div class="b7_tip_tt visible-xs-block">投递岗位:</div>
            <div v-motion-pop-visible class="b7_tip">
              <span class="hidden-xs">投递岗位,</span>请将简历发送到: 邮箱
              info@gigitech.cn,邮件标题为:岗位+姓名
            </div>

            <div v-if="!isMoblie" class="b7_content_bs">
              <swiper
                class="swipe_b7_section"
                :slides-per-view="3"
                :space-between="0"
                effect="fade"
                :modules="modules2"
                :navigation="{
                  nextEl: '.swiper_button_next',
                  prevEl: '.swiper_button_prev',
                }"
                @slideChange="onSlideB7Change"
              >
                <swiper-slide>
                  <div class="b7_bs_item">
                    <div class="_title">产品经理 / Products Manager</div>
                    <p class="_p">广州, 全职</p>
                    <p class="b7_bs_item_p">
                      对产品整体规划、设计、优化和推广的专业人员
                    </p>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="b7_bs_item">
                    <div class="b7_bs_item_title">
                      产品经理 / Products Manager
                    </div>
                    <p class="b7_bs_item_p">广州, 全职</p>
                    <p class="b7_bs_item_p">
                      对产品整体规划、设计、优化和推广的专业人员
                    </p>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="b7_bs_item">
                    <div class="b7_bs_item_title">
                      产品经理 / Products Manager
                    </div>
                    <p class="b7_bs_item_p">广州, 全职</p>
                    <p class="b7_bs_item_p">
                      对产品整体规划、设计、优化和推广的专业人员
                    </p>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="b7_bs_item">
                    <div class="b7_bs_item_title">
                      产品经理 / Products Manager
                    </div>
                    <p class="b7_bs_item_p">广州, 全职</p>
                    <p class="b7_bs_item_p">
                      对产品整体规划、设计、优化和推广的专业人员
                    </p>
                  </div>
                </swiper-slide>
              </swiper>
              <div
                v-show="currentTb7Index != 2"
                class="swiper_button_next"
              ></div>
              <div
                v-show="currentTb7Index != 1"
                class="swiper_button_prev"
              ></div>
            </div>

            <div v-else class="b7_content_bs_m">
              <div v-motion-pop-visible class="b7_bs_item_m">
                <div class="b7_bs_item_title">产品经理 / Products Manager</div>
                <p class="b7_bs_item_p">广州, 全职</p>
                <p class="b7_bs_item_p">
                  对产品整体规划、设计、优化和推广的专业人员
                </p>
              </div>
              <div v-motion-pop-visible class="b7_bs_item_m">
                <div class="b7_bs_item_title">产品经理 / Products Manager</div>
                <p class="b7_bs_item_p">广州, 全职</p>
                <p class="b7_bs_item_p">
                  对产品整体规划、设计、优化和推广的专业人员
                </p>
              </div>
              <div v-motion-pop-visible class="b7_bs_item_m">
                <div class="b7_bs_item_title">产品经理 / Products Manager</div>
                <p class="b7_bs_item_p">广州, 全职</p>
                <p class="b7_bs_item_p">
                  对产品整体规划、设计、优化和推广的专业人员
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section_b8 panel">
        <div class="main_contain">
          <div class="b8_boxs">
            <div v-motion-pop-visible class="b8_title hidden-xs">下载中心</div>
            <div class="b8_main_bs">
              <div v-motion-pop-visible class="b8_main_item">
                <div class="b8_main_item_t">
                  ——————<span>医生端</span>——————
                </div>
                <div class="b8_main_item_download">
                  <div class="b8_main_item_d1">
                    <div class="b8_main_item_d2">
                      <img
                        class="b8_item_code"
                        src="@/assets/img/android_pro.png"
                        alt=""
                      />
                      <div class="b8_main_item_tt">APP端</div>
                    </div>
                    <div class="b8_main_item_d2">
                      <img
                        class="b8_item_code"
                        src="@/assets/img/wechat_pro.png"
                        alt=""
                      />
                      <div class="b8_main_item_tt">小程序端</div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-motion-pop-visible class="b8_main_item">
                <div class="b8_main_item_t">
                  ——————<span>患者端</span>——————
                </div>
                <div class="b8_main_item_download">
                  <!-- <div class="b8_main_item_d1">
                    <div class="b8_main_item_d2">敬请期待</div>
                    <div class="b8_main_item_d2">敬请期待</div>
                  </div> -->
                  <div class="b8_main_item_d1 b8_main_item_d4">
                    <div class="b8_main_item_d2">
                      <img
                        class="b8_item_code"
                        src="@/assets/img/wecode_patient.jpg"
                        alt=""
                      />
                      <div class="b8_main_item_tt">小程序端</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 留言板 -->
    <Transition name="certificate">
      <div v-show="isShowAds" @click="isShowAds = false" class="contain_ads">
        <div v-motion-slide-top @click.stop class="ads_boxs">
          <div class="ads_title">留言板</div>
          <textarea
            v-model="messageContent"
            class="ads_input"
            type="text"
            maxlength="300"
            placeholder="请输入留言内容"
          />
          <div class="ads_btn" @click="submitAll">提交</div>
        </div>
      </div>
    </Transition>

    <div class="container horizontal"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { onEvent, offEvent, emitEvent } from "@/utils/eventBus";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import banner_product_all_m from "@/assets/img/banner_product_all_m.png";

import banner_product_b8c1_m from "@/assets/img/banner_product_b8c1_m.png";
import banner_product_b8c2_m from "@/assets/img/banner_product_b8c2_m.png";
import banner_product_b8c3_m from "@/assets/img/banner_product_b8c3_m.png";
import banner_product_b8c4_m from "@/assets/img/banner_product_b8c4_m.png";
import { ElMessage } from "element-plus";
import "element-plus/dist/index.css";
import axios from "axios";

const isMoblie = ref(false);
const route = useRoute();
const router = useRouter();
const viewportHeight = ref();
const currentB3Index = ref(1);
const currentB2Index = ref(1);
const currentB8Index = ref(1);
const currentTbIndex = ref(1);
const currentTb7Index = ref(1);
const currentTb5Index = ref(1);
const modules = [Navigation, Pagination];
const imgLists = ref([
  banner_product_b8c1_m,
  banner_product_b8c2_m,
  banner_product_b8c3_m,
  banner_product_b8c4_m,
]);

const modules2 = [Navigation];
const infoFrom = ref({
  name: "",
  email: "",
  phone: "",
  company: "",
});
const messageContent = ref("");
const isShowAds = ref(false);
const isloading = ref(false);

const mySwiper = ref();
const onSwiper = (swiper) => {
  mySwiper.value = swiper;
};

const onSlideChange = (swiper) => {
  currentB2Index.value = swiper.activeIndex + 1;
};

const onSlideB2Change = (swiper) => {
  currentTbIndex.value = swiper.activeIndex + 1;
};

const onSlideB5Change = (swiper) => {
  currentTb5Index.value = swiper.activeIndex + 1;
};

const onSlideB7Change = (swiper) => {
  currentTb7Index.value = swiper.activeIndex + 1;
};

const goToSlide = (index) => {
  if (mySwiper.value) {
    mySwiper.value.slideTo(index);
    currentB2Index.value = index + 1;
  }
};

const mySwiperB8 = ref();
const onSwiperB8 = (swiper) => {
  mySwiperB8.value = swiper;
};

const onSlideChangeB8 = (swiper) => {
  currentB8Index.value = swiper.activeIndex + 1;
};

const goToSlideB8 = (index) => {
  if (mySwiperB8.value) {
    mySwiperB8.value.slideTo(index);
    currentB8Index.value = index + 1;
  }
};

const showMessage = (message, type = "warning") => {
  // 创建消息元素
  const messageEl = document.createElement("div");
  messageEl.className = `custom-message custom-message-${type}`;
  messageEl.textContent = message;

  // 添加到body
  document.body.appendChild(messageEl);

  // 显示动画
  setTimeout(() => {
    messageEl.style.opacity = "1";
    messageEl.style.transform = "translate(-50%, 0)";
  }, 0);

  // 3秒后移除
  setTimeout(() => {
    messageEl.style.opacity = "0";
    messageEl.style.transform = "translate(-50%, -20px)";
    setTimeout(() => {
      document.body.removeChild(messageEl);
    }, 300);
  }, 3000);
};

const takeItShow = () => {
  // 验证表单
  if (!infoFrom.value.name) {
    showMessage("请输入您的称呼");
    return;
  }
  if (!infoFrom.value.email) {
    showMessage("请输入您的邮箱");
    return;
  }
  if (!infoFrom.value.phone) {
    showMessage("请输入您的电话");
    return;
  }
  if (!infoFrom.value.company) {
    showMessage("请输入所在公司");
    return;
  }

  // 所有验证通过后显示留言板
  isShowAds.value = true;
};

// 创建axios实例
const request = axios.create({
  headers: {
    "tenant-id": "1",
  },
});

const submitAll = async () => {
  if (isloading.value) {
    return;
  }
  try {
    isloading.value = true;
    setTimeout(() => {
      isloading.value = false;
    }, 3000);
    const response = await request.post("/app-api/member/index/form", {
      mobile: infoFrom.value.phone,
      email: infoFrom.value.email,
      nickname: infoFrom.value.name,
      company: infoFrom.value.company,
      content: messageContent.value,
    });
    isloading.value = false;
    if (response.data.code === 200 || response.data.code === 0) {
      showMessage("提交成功", "success");
      // 清空表单
      infoFrom.value = {
        name: "",
        email: "",
        phone: "",
        company: "",
      };
      messageContent.value = "";
      // 关闭留言板
      isShowAds.value = false;
    } else {
      showMessage(response.data.msg || "提交失败", "error");
    }
  } catch (error) {
    showMessage("网络错误，请稍后重试", "error");
    console.error("提交失败:", error);
  }
};

const getImageDimensions = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () =>
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
    img.onerror = reject;
    img.src = src;
  });
};

const pswpInstance = ref(null);

const destroyGallery = () => {
  if (pswpInstance.value) {
    pswpInstance.value.destroy();
    pswpInstance.value = null;
  }
};

const openItemGallery = async (url) => {
  destroyGallery();
  const dimensions = await getImageDimensions(url);
  pswpInstance.value = new PhotoSwipeLightbox({
    dataSource: [{ src: url, ...dimensions }],
    pswpModule: () => import("photoswipe"),
    index: 0,
    zoom: true,
    showHideAnimationType: "fade",
  });
  pswpInstance.value.init();
  pswpInstance.value.loadAndOpen(0);
};

const openGallery = async (url) => {
  destroyGallery();
  let cIndex = 0;
  cIndex = imgLists.value.findIndex((item) => item == url);
  console.log("cIndex", cIndex);
  const dataSource = await Promise.all(
    imgLists.value.map(async (item) => ({
      src: item,
      ...(await getImageDimensions(item)),
    }))
  );

  pswpInstance.value = new PhotoSwipeLightbox({
    dataSource: dataSource,
    pswpModule: () => import("photoswipe"),
    index: Math.max(cIndex, 0),
    zoom: true,
    showHideAnimationType: "fade",
  });
  pswpInstance.value.init();
  pswpInstance.value.loadAndOpen(Math.max(cIndex, 0));
};

const initMap = () => {
  if (window.BMapGL) {
    const map = new window.BMapGL.Map("allmap"); // 创建地图实例
    const point = new window.BMapGL.Point(116.404, 39.915); // 设置中心点坐标
    map.centerAndZoom(point, 16); // 初始化地图，设置中心点坐标和地图级别
    map.disableScrollWheelZoom(); // 开启鼠标滚轮缩放

    const geocoder = new window.BMapGL.Geocoder();
    // 要显示的地址
    const address = "广州市珠江新城兴民路222号天盈广场西塔1905室";

    const getCoordinates = (address) => {
      geocoder.getPoint(
        address,
        (point) => {
          if (point) {
            // 设置地图中心点
            map.centerAndZoom(point, 16);

            // 添加标记
            const marker = new window.BMapGL.Marker(point);
            map.addOverlay(marker);

            // 添加信息窗口
            const infoWindow = new window.BMapGL.InfoWindow(address);
            marker.addEventListener("click", () => {
              map.openInfoWindow(infoWindow, point);
            });

            // 使用 geocoder.getLocation 获取详细的地理编码信息
            geocoder.getLocation(point, (result) => {
              if (result) {
                // 返回详细的地理编码信息，包含地址、省市区等

                // 创建信息窗口内容
                const infoContent = `<div class="company_boxs">
                  <div class="company_title">联系我们</div>
                <div class="company_bb"><div class="company_label">联系电话：</div>13759982847</div>
                <div class="company_bb"><div class="company_label">邮箱：</div>info@gigitech.cn</div>
                <div class="company_bb"><div class="company_label">详细地址：</div>${address}</div></div> `;

                // 创建信息窗口
                const infoWindow = new window.BMapGL.InfoWindow(infoContent, {
                  width: 300, // 固定宽度
                  height: 0,
                  offset: new window.BMapGL.Size(0, -20), // 调整位置偏移（可选）
                });

                // 在地图加载时直接展示信息窗口
                map.openInfoWindow(infoWindow, point);

                // 添加标记点击事件
                marker.addEventListener("click", () => {
                  map.openInfoWindow(infoWindow, point);
                });
              }
            });
          } else {
            console.error("无法解析地址：" + address);
          }
        },
        "广州市" // 可选：指定城市以提高解析精度
      );
    };

    getCoordinates(address);
  }
};

const initGsap = () => {
  const container = document.querySelector(".swipe-section");
  const panels = gsap.utils.toArray(".panel"); // 获取所有 panel 元素
  console.log("panels", panels);
  const panelNum = panels.length;
  let panelIncrement = 1 / (panelNum - 1);
  const endValue = () => container.scrollHeight - window.innerHeight;
  ScrollTrigger.create({
    trigger: container,
    start: "top top",
    end: () => endValue,
    snap: {
      snapTo: panelIncrement,
      duration: { min: 0.3, max: 0.6 },
      ease: "power1.inOut",
    },
  });
};

const handleMessage = (partIndex) => {
  const sectionWrap = document.querySelector(`.section_b${partIndex}`);
  if (sectionWrap) {
    sectionWrap.scrollIntoView({ behavior: "smooth" });
  }
};

const setRootFontSize = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth <= 768) {
    isMoblie.value = true;
    document.documentElement.style.fontSize = `${screenWidth / 7.5}px`; // 750px 设计稿 → 1rem = 100px
  } else {
    isMoblie.value = false;
    document.documentElement.style.fontSize = "16px"; // 固定字号
  }
};

const throttle = (fn, delay) => {
  let lastCall = 0;
  return (...args) => {
    const now = Date.now();
    if (now - lastCall < delay) return;
    lastCall = now;
    fn(...args);
  };
};

const handleScroll = () => {
  let panels = document.querySelectorAll(".panel");
  const scrollPosition = window.scrollY + window.innerHeight / 3;
  if (panels && panels.length) {
    panels.forEach((item, index) => {
      const panelTop = item.offsetTop;
      const panelHeight = item.offsetHeight;
      const panelBottom = panelTop + panelHeight;
      if (scrollPosition >= panelTop && scrollPosition < panelBottom) {
        emitEvent("getNav", index);
      }
    });
  }
};

// 添加视口高度计算
const setViewportHeight = () => {
  // 获取多种可能的高度值
  const heights = [
    window.outerHeight,
    window.innerHeight,
    document.documentElement.clientHeight,
    document.body.clientHeight,
    window.screen.height,
    window.visualViewport?.height || 0,
  ].filter((height) => height > 0); // 过滤掉无效值

  // 使用最大的高度值
  const vh = Math.max(...heights);

  const s1heights = window.innerHeight;

  // 设置CSS变量
  document.documentElement.style.setProperty("--vh", `${vh}px`);
  document.documentElement.style.setProperty("--vh1", `${s1heights}px`);

  // 在UC浏览器中，可能需要额外处理
  if (navigator.userAgent.toLowerCase().indexOf("ucbrowser") > -1) {
    // 添加一个延时重新计算，因为UC浏览器可能需要一些时间来正确计算高度
    setTimeout(() => {
      const ucHeight = Math.max(...heights);
      document.documentElement.style.setProperty("--vh", `${ucHeight}px`);
    }, 100);
  }
};

onMounted(() => {
  onEvent("partIndex", handleMessage);
  window.addEventListener("resize", setRootFontSize);
  window.addEventListener("scroll", throttle(handleScroll, 300));
  setRootFontSize();
  setViewportHeight();
  nextTick(() => {
    // initMap();
    if (!isMoblie.value) {
      initGsap();
    }
    viewportHeight.value = document.documentElement.clientHeight;

    const partIndex = Number(route.query.part);
    if (Number.isInteger(partIndex) && partIndex >= 1 && partIndex <= 8) {
      handleMessage(partIndex);
      router.replace({ path: "/" });
    }
  });
});

onUnmounted(() => {
  offEvent("partIndex", handleMessage);
  window.removeEventListener("resize", setRootFontSize);
  window.removeEventListener("scroll", throttle(handleScroll, 100));
});
</script>

<style lang="scss">
.BMap_bubble_pop {
  border-radius: 20px !important;
  border: 0 !important;
  padding: 0 !important;
}
.BMap_bubble_content {
  width: 300px !important;
}
.BMap_bubble_top {
  height: 32px !important;
}

.company_boxs {
  padding: 0 20px 10px 20px;
  width: 100%;

  .company_title {
    color: #fff;
    background: #29a69c;
    width: 100px;
    text-align: center;
    height: 28px;
    line-height: 28px;
    border-radius: 20px;
    margin: 0px auto 10px;
  }
}
.company_bb {
  display: flex;
  color: #000;
}
.company_label {
  min-width: 80px;
  text-align: left;
  color: #000;
}
.swiper {
  position: relative;
}
.swiper-pagination-bullets {
  top: 0px !important;
  height: 30px;
}
.swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background: rgba(255, 255, 255, 0.4);
  opacity: 1;
  margin: 0 10px !important;
}
.swiper-pagination-bullet-active {
  background: #fff;
}

/* 自定义导航按钮定位 */
.swiper_button_next,
.swiper_button_prev {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;

  &:hover {
    opacity: 0.8;
  }
}

/* 右侧按钮定位 */
.swiper_button_next {
  right: 0px;
}

/* 左侧按钮定位 */
.swiper_button_prev {
  left: 0px;
}

/* 覆盖默认按钮样式 */
.swiper_button_next::after,
.swiper_button_prev::after {
  content: "";
  display: block;
  width: 12px;
  height: 12px;
  border-top: 2px solid white;
  border-right: 2px solid white;
  position: absolute;
  top: 50%;
  left: 50%;
}

/* 右侧箭头方向 */
.swiper_button_next::after {
  transform: translate(-60%, -50%) rotate(45deg);
}

/* 左侧箭头方向 */
.swiper_button_prev::after {
  transform: translate(-40%, -50%) rotate(-135deg);
}

.custom-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 20px;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  z-index: 9999;
  opacity: 0;
  transition: all 0.3s ease;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  &.custom-message-warning {
    background-color: #e6a23c;
  }

  &.custom-message-success {
    background-color: #67c23a;
  }

  &.custom-message-error {
    background-color: #f56c6c;
  }

  &.custom-message-info {
    background-color: #909399;
  }
}
</style>

<style lang="scss" scoped>
$r: 50;

@keyframes wrap-eye-float {
  0%,
  100% {
    transform: translate(-50%, calc(-50% - 12px));
  }
  50% {
    transform: translate(-50%, calc(-50% + 12px));
  }
}

.home {
  .swipe-section {
    width: 100%;
  }

  .ban_title_boxs {
    display: flex;
    .ban_title {
      font-size: 21px;
      background: transparent;
      color: #fff;
      border-radius: 30px;
      border: 1px solid #fff;
      width: 180px;
      height: 42px;
      line-height: 40px;
      margin-bottom: 30px;
      letter-spacing: 2px;
      transition: color 0.5s;
      cursor: pointer;
      font-weight: 500;
      z-index: 3;
    }
    .ban_title_active {
      color: #29a69c;
    }
    .active_block {
      content: "";
      position: absolute;
      width: 180px;
      height: 42px;
      background: #fff;
      border-radius: 30px;
      transition: all 0.5s;
      transform: translate(calc(var(--offset-multiple) * 180px));
    }
  }

  .certificate-enter-active,
  .certificate-leave-active {
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .certificate-enter-from,
  .certificate-leave-to {
    opacity: 0;
    transform: translateY(10px);
  }

  .section_b1 {
    position: relative;
    height: 100vh;
    width: 100%;
    background: url("@/assets/img/banner5.jpg") no-repeat center/cover;
    .wrap_title_boxs {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .banner_logo {
        height: 100px;
        margin-bottom: 16px;
      }

      .wrap_title {
        font-size: 48px;
        color: #fff;
        letter-spacing: 12px;
        font-weight: 400;
        word-break: keep-all;
      }

      .wrap_tip {
        width: fit-content;
        font-size: 20px;
        color: #fff;
        font-weight: 400;
        margin-top: 2px;
        letter-spacing: 1px;
        padding: 8px 30px;
        border-radius: 20px;
        background: #25b3a8;
        margin-top: 30px;
        line-height: 1.2;
      }
    }

    .wrap_eye {
      height: 591px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, calc(-50% - 12px));
      animation: wrap-eye-float 5s ease-in-out infinite;

      @media (prefers-reduced-motion: reduce) {
        animation: none;
        transform: translate(-50%, -50%);
      }
    }

    .wrap_bottom_com {
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      color: #fff;
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translate(-50%, 0);
      letter-spacing: 1px;
      border: 1px solid #fff;
      padding: 8px 50px;
      border-radius: 30px;
      word-break: keep-all;
    }
  }

  .section_b2 {
    height: 100vh;
    overflow: hidden;
    position: relative;
    .section_b2_top {
      height: 556px;
      width: 100%;
      background: url("@/assets/img/banner7.jpg") no-repeat center/cover;
    }

    .section_b2_bottom {
      height: calc(100vh - 556px);
      width: 100%;
      background: #29a69c;
      padding-top: 30px;
      .b2_tboxs {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .b2_content {
        font-size: 20px;
        width: 930px;
        line-height: 34px;
        color: #fff;
        letter-spacing: 2px;
        font-weight: 400;
        span {
          font-size: 23px;
          font-weight: 600;
        }
      }
    }

    .section_b2_certificate {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgb(0 68 68 / 60%);
      z-index: 20;
      transition: all 0.5s;
      .section_b2_cswiper {
        margin-top: 150px;
      }
      .swiper_b2_section {
        width: 100%;
        .swiper_b2_item {
          padding-top: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          .swiper_box_img {
            height: 382px;
          }
        }
      }
    }
  }

  .section_b3 {
    height: 100vh;
    width: 100%;
    background: url("@/assets/img/banner8.jpg") no-repeat center/cover;

    .main_contain {
      height: 100%;
      position: relative;
    }
    .section_b3_boxs {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 600px;
      position: absolute;
      top: 50%;
      margin-top: -266px;
    }

    .swipe_b3_section {
      width: 100%;
    }
    .b3_main_act {
      margin-top: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .b3_main_tt {
        padding: 32px 0;
        width: 860px;
        text-align: center;
        color: #fff;
        border-radius: 70px;
        letter-spacing: 2px;
        background: #25b3a8;
        .b3_t_b1 {
          font-size: 32px;
          margin-bottom: 10px;
          font-weight: 500;
        }
        .b3_t_b2 {
          font-size: 21px;
          font-weight: 300;
        }
      }

      .b3_main_tip {
        width: 762px;
        font-size: 18px;
        color: #fff;
        line-height: 38px;
        letter-spacing: 2px;
        margin-top: 40px;
        span {
          font-size: 24px;
          font-weight: 600;
        }
      }

      .b3_main_btns {
        width: 860px;
        display: flex;
        padding: 20px 0;
        justify-content: center;
        align-items: center;
        border: 1px solid #fff;
        border-radius: 70px;
        margin-top: 35px;

        .b3_main_btn {
          width: 140px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 16px;
          color: #fff;
          background: rgba($color: #25b3a8, $alpha: 0.3);
          border-radius: 35px;
          margin: 0 12px;
        }
      }
    }

    .banner_product {
      height: 500px;
      margin: 0 auto;
      margin-top: 20px;
    }
  }

  .section_b4 {
    height: 100vh;
    width: 100%;
    background: url("@/assets/img/banner8.jpg") no-repeat center/cover;

    .ban_title_boxs {
      .ban_title {
        font-size: 16px;
        background: transparent;
        color: #fff;
        border-radius: 30px;
        border: 2px solid #fff;
        width: 200px;
        height: 42px;
        line-height: 38px;
        margin-bottom: 30px;
        letter-spacing: 2px;
        transition: color 0.5s;
        z-index: 2;
        cursor: pointer;
        font-weight: 500;
      }
      .ban_title_active {
        color: #29a69c;
      }
      .active_block {
        content: "";
        position: absolute;
        width: 200px;
        height: 42px;
        background: #fff;
        border-radius: 30px;
        transition: all 0.5s;
        transform: translate(calc(var(--offset-multiple) * 200px));
      }

      display: flex;
      z-index: 88;
    }
    .main_contain {
      height: 100%;
      position: relative;
    }
    .section_b4_boxs {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      position: absolute;
      top: 50%;
      margin-top: -266px;
    }
    .swipe_b4_section {
      width: 100%;
    }
    .banner_product {
      height: 500px;
      margin: 0 auto;
      margin-top: 20px;
    }
  }

  .section_b5 {
    height: 100vh;
    overflow: hidden;
    .section_b5_top {
      height: 556px;
      width: 100%;
      background: url("@/assets/img/banner6.jpg") no-repeat center/cover;
    }
    .section_b5_bottom {
      height: calc(100vh - 556px);
      width: 100%;
      background: #29a69c;
      padding-top: 30px;

      .b5_tboxs {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .b5_title {
        font-size: 21px;
        padding: 8px 35px;
        background: #fff;
        color: #25b3a8;
        border-radius: 35px;
        width: fit-content;
        margin-bottom: 30px;
        letter-spacing: 2px;
        line-height: 1.2;
      }

      .b5_main_boxs {
        display: flex;
        justify-content: center;
        color: #fff;
        width: 100%;
        position: relative;
        .b5_main_item {
          margin-right: 90px;
          width: 428px;
          letter-spacing: 2px;
          &:last-child {
            margin-right: 0;
          }

          .b5_main_item_t {
            padding-bottom: 12px;
            margin-bottom: 9px;
            border-bottom: 1px solid #fff;
            font-size: 21px;
            letter-spacing: 2px;
          }

          .b5_main_item_content {
            font-size: 18px;
            line-height: 34px;
          }
        }
      }
    }
  }

  .section_b6 {
    height: 100vh;
    overflow: hidden;
    .section_b6_top {
      height: 500px;
      width: 100%;
      background: url("@/assets/img/banner3.jpg") no-repeat center/cover;
    }
    .section_b6_bottom {
      width: 100%;
      height: calc(100vh - 500px);
      background: #29a69c;
      .main_contain {
        height: 100%;
      }
      .b6_boxs {
        display: flex;
        height: 100%;

        .b6_boxs_right {
          width: 50%;
          display: flex;
          flex-direction: column;
          padding: 40px 40px 0 40px;

          .b6_r_title {
            font-size: 16px;
            padding: 8px 0px;
            min-width: 120px;
            width: 120px;
            text-align: center;
            background: #fff;
            color: #25b3a8;
            border-radius: 35px;
            font-weight: 500;
            letter-spacing: 1px;
          }
          .b6_r_wboxs {
            color: #fff;
            letter-spacing: 1px;
            font-size: 18px;
            text-align: left;
            margin-top: 20px;
            .b6_r_wrap {
              display: flex;
              margin-bottom: 8px;
            }
          }

          .b6_rt_boxs {
            display: flex;
            align-items: center;
            justify-content: space-between;
            letter-spacing: 1px;
            margin-top: 20px;

            .b6_rt_boxs_l {
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .b6_rt_tip {
              font-size: 18px;
              color: #fff;
              margin: 0 6px;
              text-align: left;
            }

            .b6_rt_btn {
              background: #d41e6d;
              color: #fff;
              cursor: pointer;
              &:hover {
                opacity: 0.9;
              }
            }
          }
          .b6_rtt_wboxs {
            display: flex;
            flex-direction: column;
            margin-top: 40px;
            font-size: 16px;
            color: #fff;
            width: 100%;
            .b6_rtt_wrap {
              display: flex;
              margin-bottom: 40px;
              .b6_r_wrap_item {
                display: flex;
                span {
                  min-width: 80px;
                }
                .b6_r_wrap_input {
                  background: transparent;
                  color: #fff;
                  font-size: 16px;
                  border: 0;
                  padding-bottom: 4px;
                  border-bottom: 1px solid #fff;
                  margin-left: 10px;
                  flex: 1;
                  width: 100%;
                  outline: none;
                  -webkit-appearance: none; /* 关键：禁用 iOS 原生样式 */
                  -moz-appearance: none;
                  appearance: none;
                  border-radius: 0;
                  &:focus {
                    outline: none;
                    box-shadow: none;
                  }
                }
                &:first-child {
                  width: 40%;
                }
                &:last-child {
                  width: 60%;
                }
              }
            }
          }
        }

        .b6_boxs_left {
          width: 50%;
          height: 100%;
          .baiduMap {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          #allmap {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .section_b7 {
    height: 100vh;
    width: 100%;
    background: url("@/assets/img/banner4.jpg") no-repeat center/cover;
    position: relative;

    .b7_boxs {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: -300px;
      margin-left: -600px;
      width: 1200px;
      height: 600px;
      background: rgba($color: #25b3a8, $alpha: 1);
      border-radius: 70px;
      padding: 70px 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      .b7_tip {
        font-size: 21px;
        padding: 24px 50px;
        background: #d41e6d;
        color: #fff;
        border-radius: 35px;
        margin-bottom: 60px;
        line-height: 1.2;
        letter-spacing: 1px;
        text-align: center;
        font-weight: 500;

        .icon_boder_l {
          position: absolute;
          left: 0;
          top: 0;
          width: 17px;
        }
        .icon_boder_r {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 17px;
          transform: scale(-1);
        }
      }

      .b7_content_bs {
        display: flex;
        align-items: center;
        width: 100%;
        .swipe_b7_section {
          width: 100%;
        }
        .b7_bs_item {
          width: 280px;
          height: 200px;
          padding: 30px 30px;
          background: rgba($color: #54b8af, $alpha: 1);
          border-radius: 35px;
          color: #fff;
          margin: 20px auto;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          font-size: 16px;
          text-align: left;
          font-weight: 500;
          box-shadow: 3px 3px 20px 3px #00000026;

          .b7_bs_item_title {
            padding-bottom: 10px;
            width: 100%;
            border-bottom: 1px solid #fff;
            margin-bottom: 10px;
          }

          .b7_bs_item_p {
            margin: 6px 0;
            font-size: 16px;
            display: flex;
            align-items: flex-start;
            &::before {
              content: "";
              display: block;
              min-width: 6px;
              margin-top: 8px;
              height: 6px;
              width: 6px;
              border-radius: 50%;
              background: #fff;
              margin-right: 6px;
            }
          }
        }
      }
      .swiper_button_next,
      .swiper_button_prev {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10;
        cursor: pointer;
        width: 40px;
        height: 40px;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 50%;
        margin-top: 30px;
      }

      .swiper_button_next {
        right: 20px;
      }

      .swiper_button_prev {
        left: 20px;
      }
    }
  }

  .section_b8 {
    height: 100vh;
    width: 100%;
    background: url("@/assets/img/banner1.jpg") no-repeat center/cover;
    .main_contain {
      height: 100%;
      position: relative;
    }
    .b8_boxs {
      width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding-top: 34px;

      .b8_title {
        font-size: 21px;
        padding: 8px 35px;
        background: #fff;
        color: #25b3a8;
        border-radius: 35px;
        margin-bottom: 30px;
        line-height: 1.2;
        letter-spacing: 1px;
      }

      .b8_main_bs {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        .b8_main_item {
          width: 380px;
          margin: 0 100px;

          .b8_main_item_t {
            color: rgba(255, 255, 255, 0.6);
            font-size: 21px;
            margin-bottom: 40px;
            span {
              margin: 0 20px;
              color: #fff;
            }
          }

          .b8_main_item_download {
            margin-top: 40px;
            .b8_main_item_d1 {
              display: flex;
              width: 100%;
              align-items: center;
              justify-content: space-between;
              .b8_main_item_d2 {
                height: 180px;
                width: 157px;
                border-radius: 25px;
                background: #fff;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                color: #666;
                .b8_item_code {
                  width: 140px;
                  height: 140px;
                }
                .b8_main_item_tt {
                  font-weight: bold;
                  letter-spacing: 1px;
                  font-size: 12px;
                  margin-top: 6px;
                }
              }
            }
            .b8_main_item_d3 {
              width: 100%;
              height: 157px;
              background: #fff;
              border-radius: 25px;
              margin-top: 56px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 16px;
              color: #666;
              .b8_item_code {
                width: 140px;
                height: 140px;
              }
            }

            .b8_main_item_d4 {
              justify-content: center;
            }
          }
        }
      }
    }
  }

  .contain_ads {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgb(0 68 68 / 60%);
    z-index: 998;
    transition: all 0.5s;

    .ads_boxs {
      width: 480px;
      height: 640px;
      background: #fff;
      border-radius: 30px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: -320px;
      margin-left: -240px;
      padding: 30px;

      .ads_title {
        color: #5f5f5f;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 16px;
      }

      .ads_input {
        width: 100%;
        height: 460px;
        background: #f3f3f3;
        border-radius: 24px;
        border: 0;
        font-size: 18px;
        padding: 20px;
        resize: none;
        &:focus-visible {
          outline: #29a69c auto 1px;
        }
      }

      .ads_btn {
        font-size: 18px;
        height: 42px;
        line-height: 42px;
        width: 180px;
        min-width: 180px;
        text-align: center;
        background: #d41e6d;
        color: #fff;
        border-radius: 40px;
        font-weight: 500;
        letter-spacing: 0;
        padding: 0;
        margin: 20px auto 0;
        cursor: pointer;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
}

.section_hh {
  .section_ttbg {
    height: 320px !important;
  }
  .section_b2 {
    .section_b2_bottom {
      height: calc(100vh - 320px) !important;
    }
    .swiper_button_next {
      right: 20px !important;
    }
    .swiper_button_prev {
      left: 20px !important;
    }
  }

  .section_b5 {
    .section_b5_bottom {
      height: calc(100vh - 320px) !important;
      .b5_main_boxs .b5_main_item {
        margin-right: 50px;
        width: 450px;
      }
    }
  }

  .section_b4_bottom {
    height: calc(100vh - 320px) !important;
  }

  .section_b6 {
    .section_b6_bottom {
      height: calc(100vh - 320px) !important;
      .b6_boxs .b6_boxs_right {
        padding: 20px 20px 20px 20px;
        .b6_rtt_wboxs {
          margin-top: 20px;
        }
      }
    }
  }

  .section_b7 {
    .b7_boxs {
      padding: 40px 60px;
      width: 1040px;
      height: 500px;
      margin-top: -216px;
      margin-left: -500px;
      .b7_content_bs .b7_bs_item {
        box-shadow: 3px 3px 10px 3px #00000026;
      }
      .swiper_button_next,
      .swiper_button_prev {
        margin-top: 40px;
      }
    }
  }

  .platform_boxs {
    padding-top: 120px;
  }

  .b7_boxs {
    height: 500px;
    margin-top: -250px;
  }
}

// 笔记本
@media (max-width: 1600px) {
  .home {
    .section_b3 {
      .banner_product {
        height: auto;
        width: 1200px;
      }
    }
    .section_b4 {
      .banner_product {
        height: auto;
        width: 1200px;
      }
    }
  }
}

@media (max-width: 1400px) {
  .home {
    .section_b3 {
      .banner_product {
        height: auto;
        width: 1000px;
      }
    }
    .section_b4 {
      .banner_product {
        height: auto;
        width: 1000px;
      }
    }
  }
}

@media (max-width: 1200px) {
  .home {
    .section_b3 {
      .banner_product {
        width: 980px;
      }
    }
    .section_b4 {
      .banner_product {
        width: 980px;
      }
    }

    .section_b5 .section_b5_bottom .b5_main_boxs .b5_main_item {
      .b5_main_item_content {
        font-size: 16px;
        letter-spacing: 1px;
      }
    }

    .section_b6 .section_b6_bottom .b6_boxs .b6_boxs_right {
      padding: 20px;
      .b6_r_wboxs {
        font-size: 16px;
      }
      .b6_rt_boxs .b6_rt_tip {
        font-size: 16px;
      }
    }

    .section_b8 .b8_boxs .b8_main_bs .b8_main_item {
      margin: 0 50px;
    }
  }
}

@media (max-width: 750px) {
  .home {
    overflow: hidden;
    font-size: 16rem / $r;
    background: #29a69c;

    .ban_title_boxs {
      display: flex;
      .ban_title {
        width: 100rem / $r;
        height: 25rem / $r;
        font-size: 13rem / $r;
        line-height: 25rem / $r;
        letter-spacing: 0;
        background: transparent;
        color: #fff;
        border-radius: 13rem / $r;
        border: 1px solid #fff;
        margin-bottom: 30px;
        transition: color 0.5s;
        cursor: pointer;
        font-weight: 500;
        z-index: 3;
      }
      .ban_title_active {
        color: #29a69c;
      }
      .active_block {
        content: "";
        position: absolute;
        width: 100rem / $r;
        height: 25rem / $r;
        background: #fff;
        border-radius: 13rem / $r;
        transition: all 0.5s;
        transform: translate(calc(var(--offset-multiple) * 100rem / $r));
      }
    }

    .section_b1 {
      position: relative;
      width: 100%;
      background: url("@/assets/img/b1_m.jpg") no-repeat center/cover;

      .wrap_eye {
        display: none;
      }

      .wrap_title_boxs {
        .banner_logo {
          height: 60rem / $r;
          margin-bottom: 18rem / $r;
        }
        .wrap_title {
          font-size: 32rem / $r;
          letter-spacing: 0;
        }
        .wrap_tip {
          font-size: 12rem / $r;
          padding: 6rem / $r 27rem / $r;
          margin-top: 18rem / $r;
        }
      }

      .wrap_bottom_com {
        font-size: 12rem / $r;
        padding: 3rem / $r 15rem / $r;
        position: absolute;
        bottom: 60rem / $r;
      }
    }

    .section_b2 {
      .section_b2_top {
        height: 50% !important;
        min-height: 50%;
        width: 100%;
        background: url("@/assets/img/b2_m.jpg") no-repeat center/cover;
      }
      .section_b2_bottom {
        height: 50% !important;
        min-height: 50%;
        width: 100%;

        .b2_tboxs {
          .ban_title_boxs {
            .ban_title {
              width: 100rem / $r;
              height: 25rem / $r;
              font-size: 13rem / $r;
              line-height: 25rem / $r;
              letter-spacing: 0;
              border-radius: 13rem / $r;
            }
            .active_block {
              content: "";
              width: 100rem / $r;
              height: 25rem / $r;
              position: absolute;
              background: #fff;
              border-radius: 13rem / $r;
              transition: all 0.5s;
              transform: translate(calc(var(--offset-multiple) * 100rem / $r));
            }
          }
        }

        .b2_content {
          width: 270rem / $r;
          font-size: 14rem / $r;
          line-height: 27rem / $r;
          letter-spacing: 1rem / $r;
          text-align: center;
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          span {
            font-size: 17rem / $r;
            word-break: keep-all;
          }
        }
      }

      .section_b2_certificate {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgb(0 68 68 / 60%);
        z-index: 20;
        transition: all 0.5s;
        .section_b2_cswiper {
          margin-top: 100rem / $r;
        }
        .swiper_b2_section {
          width: 100%;
          .swiper_b2_item {
            padding-top: 50rem / $r;
            display: flex;
            align-items: center;
            justify-content: center;
            .swiper_box_img {
              width: calc(100% - 40rem / $r);
              height: auto;
            }
            .swiper_box_img2 {
              width: 240rem / $r;
            }
          }
        }
        .swiper_button_next,
        .swiper_button_prev {
          display: none;
        }
      }
    }

    .section_b3 {
      width: 100%;
      background: url("@/assets/img/b3_m.jpg") no-repeat center/cover;
      .section_b3_boxs {
        height: 100%;
        top: 0;
        margin-top: 0;

        .swipe_b3_section {
        }
      }
      .b3_main_act {
        margin-top: 10rem / $r;
        .b3_main_tt {
          width: 306rem / $r;
          padding: 16rem / $r 60rem / $r;
          border-radius: 40rem / $r;

          .b3_t_b1 {
            font-size: 24rem / $r;
            font-weight: 600;
            letter-spacing: 2px;
            margin-bottom: 3rem / $r;
          }
          .b3_t_b2 {
            font-size: 12rem / $r;
            letter-spacing: 1px;
          }
        }

        .b3_main_tip {
          font-size: 14rem / $r;
          margin-top: 35rem / $r;
          width: 263rem / $r;
          line-height: 25rem / $r;
          span {
            display: block;
            margin-bottom: 9rem / $r;
            font-size: 24rem / $r;
          }
        }

        .b3_main_btns {
          width: 306rem / $r;
          margin-top: 22rem / $r;
          padding: 25rem / $r 10rem / $r;
          flex-wrap: wrap;
          justify-content: space-evenly;

          .b3_main_btn {
            width: 96rem / $r;
            height: 34rem / $r;
            line-height: 34rem / $r;
            font-size: 12rem / $r;
            margin: 10rem / $r 0;
            border-radius: 12rem / $r;
          }
        }
      }
      .banner_product {
        width: calc(100% - 40rem / $r);
        margin-top: 10rem / $r;
        margin-left: 20rem / $r;
      }
    }

    .section_b4 {
      width: 100%;
      background: url("@/assets/img/b3_m.jpg") no-repeat center/cover;
      .section_b4_boxs {
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin-top: 0;
        .ban_title_boxs {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin-bottom: 10rem / $r;
          .ban_title {
            width: 133rem / $r;
            height: 25rem / $r;
            font-size: 12rem / $r;
            line-height: 25rem / $r;
            letter-spacing: 0;
            background: transparent;
            color: #fff;
            border-radius: 13rem / $r;
            border: 1px solid #fff;
            margin-bottom: 20rem / $r;
            cursor: pointer;
            font-weight: 500;
            z-index: 3;
          }
          .ban_title_active {
            color: #29a69c;
            background: #fff;
          }
          .active_block {
            display: none;
          }
        }

        .swipe_b4_section {
        }
      }

      .banner_product {
        width: calc(100% - 40rem / $r);
        margin-top: 0;
        margin-left: 20rem / $r;
      }
    }

    .section_b5 {
      .section_b5_top {
        height: 50%;
        min-height: 50%;
        width: 100%;
        background: url("@/assets/img/banner5_m.jpg") no-repeat center/cover;
      }
      .section_b5_bottom {
        height: 50%;
        min-height: 50%;
        padding-top: 0;
        .b5_tboxs {
          .b5_title {
            font-size: 13rem / $r;
            width: 100rem / $r;
            height: 24rem / $r;
            line-height: 24rem / $r;
            padding: 0;
            letter-spacing: 0;
            position: relative;
            top: -12rem / $r;
          }

          .b5_main_boxs_m {
            padding: 0 60rem / $r;
            .b5_main_item_m {
              width: 100%;

              .b5_main_item_t {
                font-weight: bold;
                font-size: 16rem / $r;
              }
              .b5_main_item_content {
                font-size: 14rem / $r;
                line-height: 30rem / $r;
              }
            }
          }
        }

        .banner_arrow {
          width: 12rem / $r;
          transform: rotate(180deg);
        }
        .banner_arrow_left {
          width: 12rem / $r;
        }
        .swiper_button_next_m {
          position: absolute;
          top: 2rem / $r;
          right: 30rem / $r;
          z-index: 10;
          cursor: pointer;
          border-radius: 50%;
        }
        .swiper_button_prev_m {
          position: absolute;
          top: 2rem / $r;
          left: 30rem / $r;
          z-index: 10;
          cursor: pointer;
        }
      }
    }

    .section_b6 {
      .section_b6_top {
        height: 50%;
        min-height: 50%;
        width: 100%;
        background: url("@/assets/img/b6_m.jpg") no-repeat center/cover;
      }
      .section_b6_bottom {
        height: 50%;
        min-height: 50%;
        .b6_boxs {
          .b6_boxs_left {
            display: none;
          }
          .b6_boxs_right {
            width: 100%;
            padding: 0 20rem / $r;
            align-items: center;
            .b6_r_title {
              font-size: 13rem / $r;
              height: 24rem / $r;
              line-height: 24rem / $r;
              width: 100rem / $r;
              min-width: 100rem / $r;
              text-align: center;
              background: #fff;
              color: #25b3a8;
              border-radius: 13rem / $r;
              font-weight: 500;
              letter-spacing: 0;
              padding: 0;
              position: relative;
              top: -12rem / $r;
            }

            .b6_r_wboxs {
              margin-top: 6rem / $r;
              width: 252rem / $r;
              font-size: 14rem / $r;
              letter-spacing: 0;
              span {
                word-break: keep-all;
              }
              .b6_r_wrap {
                margin-bottom: 5rem / $r;
                letter-spacing: 1px;
              }
            }

            .b6_rt_boxs {
              margin-top: 12rem / $r;
              position: relative;
              width: 100%;
              .b6_rt_boxs_l {
                display: flex;
                justify-content: space-evenly;
                width: 100%;
                &::before,
                &::after {
                  content: "";
                  display: block;
                  width: 90rem / $r;
                  height: 1px;
                  background: #fff;
                }
                .b6_rt_tip {
                  display: none;
                }
                .b6_r_title_liu {
                  position: initial;
                }
              }
              .b6_rt_btn {
                display: none;
              }
            }

            .b6_rtt_wboxs {
              margin-top: 16rem / $r;
              font-size: 15rem / $r;
              .b6_rtt_wrap {
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                margin-bottom: 0rem / $r;

                .b6_r_wrap_item {
                  width: 100% !important;
                  margin-bottom: 16rem / $r;
                  padding: 0 !important;
                  .b6_r_wrap_input {
                    font-size: 14rem / $r;
                  }
                }
              }
            }

            .b6_rt_btn_m {
              background: #d41e6d;
              color: #fff;
              cursor: pointer;
              position: initial;
              height: 36rem / $r;
              line-height: 36rem / $r;
              width: 120rem / $r;
              border-radius: 20rem / $r;
              &:hover {
                opacity: 0.9;
              }
            }
          }
        }
      }
    }

    .b6_boxs_map {
      width: 100%;
      height: 266rem / $r;

      .baiduMap {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      #allmap {
        width: 100%;
        height: 100%;
      }
    }

    .section_b7 {
      width: 100%;
      background: url("@/assets/img/b7_m.jpg") no-repeat center/cover;
      position: relative;
      .main_contain {
        height: 100%;
      }
      .b7_boxs {
        width: 100%;
        height: auto;
        left: 0;
        margin-left: 0;
        background: transparent;
        margin-top: 0;
        padding: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 0;
        .b7_tip_tt {
          font-size: 13rem / $r;
          color: #fff;
          margin-bottom: 15rem / $r;
          line-height: 24rem / $r;
          letter-spacing: 1px;
        }
        .b7_tip {
          width: 300rem / $r;
          font-size: 13rem / $r;
          padding: 12rem / $r 20rem / $r;
          line-height: 20rem / $r;
          margin-bottom: 30rem / $r;
          word-break: break-all;
        }

        .b7_content_bs_m {
          display: flex;
          align-items: center;
          flex-direction: column;
          width: 100%;
          .b7_bs_item_m {
            width: 222rem / $r;
            height: 150rem / $r;
            padding: 20rem / $r 25rem / $r;
            background: rgba($color: #54b8af, $alpha: 1);
            border-radius: 35px;
            color: #fff;
            margin: 15rem / $r auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            font-size: 12rem / $r;
            text-align: left;
            font-weight: 500;
            box-shadow: 4px 4px 70px 0px #00000033;
            .b7_bs_item_title {
              padding-bottom: 10rem / $r;
              width: 100%;
              border-bottom: 1px solid #fff;
              margin-bottom: 10rem / $r;
              font-size: 12rem / $r;
            }

            .b7_bs_item_p {
              margin: 6rem / $r 0;
              font-size: 11rem / $r;
              display: flex;
              align-items: flex-start;
              &::before {
                content: "";
                display: block;
                min-width: 4rem / $r;
                margin-top: 6rem / $r;
                height: 4rem / $r;
                width: 4rem / $r;
                border-radius: 50%;
                background: #fff;
                margin-right: 6rem / $r;
              }
            }
          }
        }
      }
    }

    .section_b8 {
      width: 100%;
      background: url("@/assets/img/b8_m.jpg") no-repeat center/cover;
      position: relative;

      .b8_boxs {
        padding-top: 0;
        width: 100%;
        .b8_main_bs {
          display: flex;
          flex-direction: column;
          width: 100%;
          .b8_main_item {
            width: 100%;
            margin: 0;
            margin-bottom: 40rem / $r;
            &:last-child {
              margin: 0;
            }

            .b8_main_item_t {
              font-size: 14rem / $r;
            }
            .b8_main_item_download {
              margin-top: 40rem / $r;
              display: flex;
              flex-direction: column;
              align-items: center;
              .b8_main_item_d1 {
                width: 240rem / $r;
                .b8_main_item_d2 {
                  width: 100rem / $r;
                  height: 112rem / $r;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  .b8_item_code {
                    width: 80rem / $r;
                    height: 80rem / $r;
                  }
                }
              }
              .b8_main_item_d3 {
                width: 240rem / $r;
                height: 100rem / $r;
                margin-top: 28rem / $r;
                .b8_item_code {
                  width: 80rem / $r;
                  height: 80rem / $r;
                }
              }
            }
          }
        }
      }
    }

    .contain_ads {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgb(0 68 68 / 60%);
      z-index: 998;
      transition: all 0.5s;

      .ads_boxs {
        width: 330rem / $r;
        height: 450rem / $r;
        background: #fff;
        border-radius: 30rem / $r;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -225rem / $r;
        margin-left: -165rem / $r;
        padding: 28rem / $r 20rem / $r;

        .ads_title {
          color: #5f5f5f;
          font-size: 16rem / $r;
          margin-bottom: 8rem / $r;
        }

        .ads_input {
          width: 100%;
          height: 316rem / $r;
          background: #f3f3f3;
          border-radius: 16rem / $r;
          border: 0;
          font-size: 16px;
          padding: 12rem / $r;
          resize: none;
        }

        .ads_btn {
          font-size: 13rem / $r;
          height: 36rem / $r;
          line-height: 36rem / $r;
          width: 120rem / $r;
          min-width: 120rem / $r;
          text-align: center;
          background: #d41e6d;
          color: #fff;
          border-radius: 20rem / $r;
          font-weight: 500;
          letter-spacing: 0;
          padding: 0;
          margin: 15rem / $r auto 0;

          &:hover {
            opacity: 0.9;
          }
        }
      }
    }

    // .panel {
    //   height: 100vh;
    //   min-height: 932px;
    // }
    .panel {
      height: var(--vh);
      min-height: var(--vh);
    }

    .section_b1 {
      height: var(--vh1);
      min-height: var(--vh1);
    }
  }
}
</style>
